import { createFileRoute } from "@tanstack/react-router";

import { WorkoutDetail } from "@/features/training/modules/workout-detail/workout-detail";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/training/history/$workoutId")({
  loader: () => ({ crumb: m.history_own_title() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { workoutId } = Route.useParams();
  return <WorkoutDetail workoutId={workoutId} />;
}
